import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaInfoCircle,
  FaEnvelope,
  FaBuilding,
  FaHandshake,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../styles/header.css";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("home");

  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    const path = window.location.pathname;
    if (path === "/") setActiveLink("home");
    else if (path === "/properties") setActiveLink("properties");
    else if (path === "/collaborate") setActiveLink("collaborate");

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="container header-content">
          <div className="logo">
            <Link to="/">
              <img src="/logo.png" width={100} alt="Logo" title="logo" />
            </Link>
          </div>
          <nav className="nav-menu">
            <ul>
              <li>
                <Link to="/#home">{t("header.home")}</Link>
              </li>
              <li>
                <a href="/#about">{t("header.about")}</a>
              </li>
              <li>
                <a href="/#contact">{t("header.contact")}</a>
              </li>
              <li>
                <Link to="/properties">{t("header.properties")}</Link>
              </li>
              <li>
                <Link to="/collaborate">{t("header.collaborate")}</Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <div className="mobile-bottom-nav">
        <Link
          to="/#homeheroSection"
          className={`nav-item ${activeLink === "home" ? "active" : ""}`}
          onClick={() => setActiveLink("home")}
        >
          <FaHome className="nav-icon" />
          <span className="nav-label">{t("header.home")}</span>
        </Link>

        <a
          href="/#about"
          className={`nav-item ${activeLink === "about" ? "active" : ""}`}
          onClick={() => setActiveLink("about")}
        >
          <FaInfoCircle className="nav-icon" />
          <span className="nav-label">{t("header.about")}</span>
        </a>

        <a
          href="/#contact"
          className={`nav-item ${activeLink === "contact" ? "active" : ""}`}
           onClick={() => setActiveLink("contact")}
        >
          <FaEnvelope className="nav-icon" />
          <span className="nav-label">{t("header.contact")}</span>
        </a>

        <Link
          to="/properties"
          className={`nav-item ${activeLink === "properties" ? "active" : ""}`}
          onClick={() => setActiveLink("properties")}
        >
          <FaBuilding className="nav-icon" />
          <span className="nav-label">{t("header.properties")}</span>
        </Link>

        <Link
          to="/collaborate"
          className={`nav-item ${activeLink === "collaborate" ? "active" : ""}`}
          onClick={() => setActiveLink("collaborate")}
        >
          <FaHandshake className="nav-icon" />
          <span className="nav-label">{t("header.collaborate")}</span>
        </Link>
      </div>
    </>
  );
}

export default Header;
